import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment-timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (dateTimeString) => {
  const date = new Date(dateTimeString);
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};

export const formatDate3 = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure month is 2 digits
  const day = String(date.getDate()).padStart(2, '0'); // Ensure day is 2 digits
  return `${month}-${day}-${year}`;
};

export const formatDate2 = (dateTimeString) => {
  const date = new Date(dateTimeString);
  console.log(date.toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit',  }));
  return date.toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit',  });
};

export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}-${day}-${year}`;
};

export const getCurrentDate2 = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getDate = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure month is 2 digits
  const day = String(date.getDate()).padStart(2, '0'); // Ensure day is 2 digits
  return `${year}-${month}-${day}`;
};

export const formatDateForMySQL = (date) => {
  if (!(date instanceof Date)) {
    throw new TypeError('Input must be a Date object');
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');


  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // Determine AM/PM
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // Adjust hour to 12 if it is 0
  const formattedTime = `${hours}:${minutes}:00`;

  return `${year}-${month}-${day}T${formattedTime}Z`;
  
};

export const GetFormatedTimeStamp = (dateTimeString) => {
  const date = new Date(dateTimeString);

  // Get formatted date part (e.g., "June 25, 2024")
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long', // Full month name
    day: 'numeric', // Day of the month (no leading zero)
    year: 'numeric', // Full year
  });

  // Get time part
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // Determine AM/PM
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // Adjust hour to 12 if it is 0

  // Combine date and time
  const formattedTime = `${hours}:${minutes} ${ampm}`;
  return `${formattedDate} ${formattedTime}`;
};

export const GetFormatedDateStamp = (dateTimeString) => {
  const date = new Date(dateTimeString);

  // Get formatted date part (e.g., "June 25, 2024")
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long', // Full month name
    day: 'numeric', // Day of the month (no leading zero)
    year: 'numeric', // Full year
  });

  return `${formattedDate}`;
};
  
  
export const convertToEST = (dateString) => {
  // Check if the input is a valid date string
  if (!dateString || isNaN(Date.parse(dateString))) {
    throw new Error('Invalid date string');
  }
  
  // Parse the date and convert it to EST
  const estDate = dayjs(dateString).tz('America/New_York', true);
  
  // Format the date as needed for your server (e.g., ISO 8601 or MySQL format)
  return estDate.format('YYYY-MM-DD HH:mm:ss'); // Example: MySQL datetime format
};

export const convertESTToLocal = (estDateString) => {
  return moment.tz(estDateString, "America/New_York")
      .tz(moment.tz.guess())
      .format("MM/DD/YYYY");
}

export const convertESTToLocalDateTime = (estDateString) => {
  return moment.tz(estDateString, "America/New_York")
      .tz(moment.tz.guess())
      .format("MM/DD/YYYY hh:mm A");
}

export const getDateRangeLabelFromEndDate = (estEndDateString,status) => {
  if (!estEndDateString) return "";

  const localEnd = moment
    .tz(estEndDateString, "America/New_York")
    .tz(moment.tz.guess());

  const days = status === "Trial" ? 14 : 30; // Adjust days based on status

  const localStart = localEnd.clone().subtract(days, "days");

  const formattedStart = localStart.format("MMMM D");
  const formattedEnd = localEnd.format("MMMM D");

  return `${formattedStart} - ${formattedEnd}`;
};

export const adjustDate = (baseDate, days) => {
  const date = new Date(baseDate);
  date.setDate(date.getDate() + days);

  // Format as YYYY-MM-DD
  const year = date.getFullYear();
  const month = (`0${date.getMonth() + 1}`).slice(-2); // Months are 0-based
  const day = (`0${date.getDate()}`).slice(-2);

  return `${year}-${month}-${day}`;
}

export const isPayButtonDisabled = (subscriptionEndDate) => {
  const endDate = moment(subscriptionEndDate);
  const today = moment();
  return today.isBefore(endDate.clone().subtract(3, 'days'));
};



export const utcToLocalDate = (utcDateTime) => {
  const date = new Date(utcDateTime);
  
  if (isNaN(date.getTime())) {
    throw new Error('Invalid UTC date string provided');
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

export const utcToLocalDateTime = (utcDateTime) => {
  const date = new Date(utcDateTime);
  
  if (isNaN(date.getTime())) {
    throw new Error('Invalid UTC date string provided');
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
  
};

export const localToUTCDate = (localDateTime) => {
  const date = new Date(localDateTime);
  
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date provided');
  }
  
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};
